/* Still You landing-page engine (2026-09-06, V35 cart-state update 2026-09-07). Shared by every lp-* page.
   Progressive enhancement: every add-to-cart control is a native <form action="/cart/add">,
   so the purchase path works even if this script is missing. With JS: exclusive bundle
   tiers, AJAX add, theme cart drawer, in-page jumps, modals, sticky bar, tracking.
   DO NOT edit this page in the Shopify admin rich-text editor - it strips <script>, <form>
   and data-* attributes. Edit via the API (or a code editor) only. */
(function(){
'use strict';
if(document.documentElement.getAttribute('data-sy-engine'))return;
document.documentElement.setAttribute('data-sy-engine','1');
document.documentElement.classList.add('sy-js');
var ROOT=document.querySelector('.sy-adv');if(!ROOT)return;
var VARIANT=ROOT.getAttribute('data-sy-variant')||location.pathname.split('/').pop();
var PDP='/products/still-you-peri-night-gummies';
var TIERS={1:{id:46612266614886,price:'$49',was:'',label:'1 bottle',days:'60 days'},2:{id:46633970139238,price:'$69',was:'$98',label:'2 bottles',days:'120 days'},3:{id:46612266647654,price:'$89',was:'$147',label:'3 bottles',days:'180 days'}};
var IDS={};Object.keys(TIERS).forEach(function(k){IDS[String(TIERS[k].id)]=k;});
var sent={};
function eid(n){return n+'.'+Date.now()+'.'+Math.random().toString(36).slice(2,10);}
function track(name,params,once){
  if(once!==false){if(sent[name])return;sent[name]=true;}
  var p=params||{};p.lp_variant=VARIANT;p.page_path=location.pathname;
  var id=eid(name);
  try{if(window.fbq)fbq('trackCustom',name,p,{eventID:id});}catch(e){}
  try{if(window.gtag)gtag('event',name,p);}catch(e){}
  try{window.dataLayer=window.dataLayer||[];window.dataLayer.push(Object.assign({event:name,event_id:id},p));}catch(e){}
}
track('LP_View');

/* ---------- header offset + in-page jumps (the theme swallows some anchor clicks) ---------- */
function headerH(){var h=document.querySelector('.header-wrapper, sticky-header');return h?h.getBoundingClientRect().height:0;}
function jumpTo(t){
  var y=t.getBoundingClientRect().top+window.pageYOffset-headerH()-12;
  if(document.hidden){window.scrollTo(0,y);return;}
  try{window.scrollTo({top:y,behavior:'smooth'});}catch(e){window.scrollTo(0,y);}
  setTimeout(function(){if(Math.abs(window.pageYOffset-y)>60)window.scrollTo(0,y);},900);
}
document.addEventListener('click',function(e){
  if(!e.target||!e.target.closest)return;
  var a=e.target.closest('a[href^="#"], .js-jump[data-jump]');
  if(!a)return;
  var href=a.getAttribute('href')||a.getAttribute('data-jump')||'';
  if(href.charAt(0)!=='#'||href.length<2)return;
  var t=document.getElementById(href.slice(1));
  if(!t)return;
  e.preventDefault();e.stopPropagation();
  jumpTo(t);
  try{history.replaceState(null,'',href);}catch(x){}
  track('LP_Jump',{to:href,cta:(a.textContent||'').trim().slice(0,40)},false);
},true);
/* buttons that jump (sticky bar / card) */
document.addEventListener('click',function(e){
  if(!e.target||!e.target.closest)return;
  var b=e.target.closest('button.js-jump');
  if(!b||b.closest('form'))return;
  if(b.getAttribute('data-sy-mode')==='view'){e.preventDefault();track('LP_ViewCart',{tier:cartTier},false);openDrawer();return;}
  var t=document.getElementById('sy-buy')||document.getElementById('sy-offer');
  if(!t)return;
  e.preventDefault();jumpTo(t);
  track('LP_Sticky_Click',{cta:(b.textContent||'').trim().slice(0,40)},false);
},true);
/* landing header CTA: keep the shopper in this funnel */
try{
  var hc=document.querySelector('.sy-lpcta');
  var buySec=document.getElementById('sy-buy')||document.getElementById('sy-offer');
  if(hc&&buySec){hc.setAttribute('href','#'+buySec.id);}
}catch(e){}

/* ---------- modals / lightboxes ---------- */
var MD_SEL='.sy-md, .syh-sf, .sypf-sf, .syn-sf';
var mds=document.querySelectorAll(MD_SEL);
var lastFocus=null;
for(var i=0;i<mds.length;i++){if(mds[i].parentNode!==document.body)document.body.appendChild(mds[i]);}
function openMd(id,src){
  var m=document.getElementById(id);if(!m)return;
  lastFocus=src||document.activeElement;
  m.hidden=false;m.removeAttribute('hidden');
  document.body.style.overflow='hidden';
  var c=m.querySelector('.sy-md__close, .syh-sf__close, .sypf-sf__close, .syn-sf__close');
  if(c)c.focus();
  track('LP_Modal_Open',{modal:id},false);
}
function closeMd(){
  var any=false;
  for(var i=0;i<mds.length;i++){if(!mds[i].hidden){mds[i].hidden=true;any=true;}}
  if(any){document.body.style.overflow='';if(lastFocus&&lastFocus.focus)lastFocus.focus();lastFocus=null;}
}
document.addEventListener('click',function(e){
  if(!e.target||!e.target.closest)return;
  var t=e.target.closest('[data-sy-md]');
  if(t){e.preventDefault();e.stopPropagation();openMd(t.getAttribute('data-sy-md'),t);return;}
  if(e.target.closest('.sy-md__close, .syh-sf__close, .sypf-sf__close, .syn-sf__close')){e.preventDefault();closeMd();return;}
  var md=e.target.closest(MD_SEL);
  if(md&&!e.target.closest('.sy-md__panel, .syh-sf__panel, .sypf-sf__panel, .syn-sf__panel'))closeMd();
},true);
document.addEventListener('keydown',function(e){
  if(e.key==='Escape'||e.keyCode===27)closeMd();
  if((e.key==='Enter'||e.key===' ')&&e.target&&e.target.getAttribute&&e.target.getAttribute('data-sy-md')&&e.target.tagName!=='BUTTON'){e.preventDefault();openMd(e.target.getAttribute('data-sy-md'),e.target);}
});

/* ---------- tier selection (radio pages) ---------- */
function selectedTier(){
  var r=document.querySelector('input[name="sytier"]:checked');
  return r?parseInt(r.value,10):2;
}
function syncTierUI(initial){
  var t=selectedTier(),v=TIERS[t];
  var radios=document.querySelectorAll('input[name="sytier"]');
  for(var i=0;i<radios.length;i++){var lab=radios[i].closest('label');if(lab)lab.classList.toggle('sel',radios[i].checked);}
  /* guarantee-eligibility lines only apply to 2+ bottles */
  var ok=document.getElementById('syOk');
  if(ok){var lis=ok.querySelectorAll('li');for(var j=0;j<lis.length;j++){var tx=(lis[j].textContent||'').toLowerCase();if(tx.indexOf('90-day evaluation')>-1||tx.indexOf('evaluation period')>-1||tx.indexOf('90-night trial')>-1||tx.indexOf('full 90 nights')>-1||tx.indexOf('90-day trial')>-1){lis[j].style.display=t===1?'none':'';}}}
  var cs=document.getElementById('syCdS'),cp=document.querySelector('#syCard .cp'),ss=document.getElementById('syStS');
  if(cp&&!cartTier){cp.innerHTML=(v.was?'<s>'+v.was+'</s>':'')+v.price+'<small>'+v.label+'</small>';}
  /* on first paint the page's own default text stays; the sticky texts only follow a user's tier change */
  if(!initial){
    if(ss&&!cartTier&&ss.getAttribute('data-sy-dyn')!=='0'){ss.textContent=v.label+' · '+v.days+' · '+v.price;}
    if(cs&&!cartTier){cs.textContent='One gummy daily · '+v.days;}
    var sa=document.getElementById('syStA'),ca=document.getElementById('syCdA');
    /* only add-to-cart stickies take the GET label; jump-to-offer stickies keep their own wording */
    if(sa&&sa.classList.contains('js-atc')&&sa.getAttribute('data-sy-mode')!=='view'){sa.textContent='GET '+t+' · '+v.price;}
    if(ca&&ca.classList.contains('js-atc')&&ca.getAttribute('data-sy-mode')!=='view'){ca.textContent='GET '+(t===1?'1 BOTTLE':t+' BOTTLES')+' FOR '+v.price;}
  }
  var atc=document.getElementById('syAtc');
  if(atc&&atc.getAttribute('data-sy-price-in-label')==='1'){atc.textContent=atc.getAttribute('data-sy-label').replace('{price}',v.price).replace('{n}',t===1?'1 BOTTLE':t+' BOTTLES');}
  var gu=document.getElementById('syGuar');if(gu){gu.innerHTML=gu.getAttribute(t===1?'data-sy-g1':'data-sy-g2')||gu.innerHTML;}
}
document.addEventListener('change',function(e){
  if(e.target&&e.target.name==='sytier'){syncTierUI();track('LP_Tier_Select',{tier:selectedTier()},false);}
});
if(document.querySelector('input[name="sytier"]'))syncTierUI(true);

/* ---------- V35: cart state -> sticky CTAs become VIEW CART once the offer is in the cart ---------- */
var cartTier=0;
function openDrawer(){
  var drawer=document.querySelector('cart-drawer');
  if(!drawer){location.href='/cart';return;}
  setTimeout(syncCartMode,900);
  if(typeof window.syOpenCartDrawer==='function'){window.syOpenCartDrawer();return;}
  /* no Accept: application/json here - on a /pages/ URL that header returns the page JSON, not the sections */
  fetch(location.pathname+'?sections=cart-drawer,cart-icon-bubble')
    .then(function(r){return r.json();})
    .then(function(sections){
      if(typeof drawer.renderContents==='function'){drawer.renderContents({sections:sections,id:null});}
      else if(typeof drawer.open==='function'){drawer.open();}
    })
    .catch(function(){if(typeof drawer.open==='function')drawer.open();else location.href='/cart';});
}
function setCartMode(tier){
  cartTier=tier||0;
  var v=TIERS[cartTier];
  var btns=[document.getElementById('syStA'),document.getElementById('syCdA')];
  for(var i=0;i<btns.length;i++){
    var b=btns[i];if(!b)continue;
    if(!b.getAttribute('data-sy-orig'))b.setAttribute('data-sy-orig',b.innerHTML);
    if(v){b.setAttribute('data-sy-mode','view');b.textContent='VIEW CART · '+v.price;}
    else{b.removeAttribute('data-sy-mode');b.innerHTML=b.getAttribute('data-sy-orig');}
  }
  /* the sticky price/supply lines follow what is actually in the cart while in view mode */
  var cp=document.querySelector('#syCard .cp'),cs=document.getElementById('syCdS'),ss=document.getElementById('syStS');
  if(v){
    if(cp){cp.innerHTML=(v.was?'<s>'+v.was+'</s>':'')+v.price+'<small>'+v.label+' in your cart</small>';}
    if(cs){cs.textContent=v.label+' · '+v.days;}
    if(ss&&ss.getAttribute('data-sy-dyn')!=='0'){ss.textContent=v.label+' · '+v.days+' · in your cart';}
  }else if(document.querySelector('input[name="sytier"]')){syncTierUI(true);}
}
function syncCartMode(){
  fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();})
    .then(function(cart){
      var t=0;(cart.items||[]).forEach(function(it){var k=IDS[String(it.variant_id)];if(k&&it.quantity>0)t=parseInt(k,10);});
      setCartMode(t);
    }).catch(function(){});
}
syncCartMode();
window.addEventListener('pageshow',function(e){if(e.persisted)syncCartMode();});
document.addEventListener('cart-drawer:render',function(){setTimeout(syncCartMode,300);});
/* V35.4 QA fix: removing the last line item dispatches only cart-drawer:open (no :render), so the
   sticky bar / desktop card stayed in VIEW CART mode on an empty cart and the next tap opened an
   empty drawer instead of adding. Re-sync on open and on any drawer content change. */
document.addEventListener('cart-drawer:open',function(){setTimeout(syncCartMode,300);});
(function(){var d=document.querySelector('cart-drawer');if(!d||!window.MutationObserver)return;var t=null;
  new MutationObserver(function(muts){
    for(var i=0;i<muts.length;i++){var n=muts[i].target;if(n&&n.closest&&n.closest('.sy-cd-confirm,.sy-cd-guar,.sy-cd-secure,.sy-cd-express'))continue;
      clearTimeout(t);t=setTimeout(syncCartMode,250);return;}
  }).observe(d,{childList:true,subtree:true});})();

/* ---------- add to cart (exclusive tiers -> AJAX -> theme cart drawer) ---------- */
var busy=false;
function showErr(msg){
  var err=document.getElementById('syErr')||ROOT.querySelector('.err');
  if(err){err.style.display='block';if(msg)err.setAttribute('data-sy-reason',msg);}
}
function hideErr(){var err=document.getElementById('syErr')||ROOT.querySelector('.err');if(err)err.style.display='none';}
function setBusy(btn,on,label){
  if(!btn)return;
  if(on){btn.setAttribute('data-sy-label',btn.getAttribute('data-sy-label')||btn.innerHTML);btn.setAttribute('aria-busy','true');btn.disabled=true;btn.textContent=label||'Adding…';}
  else{btn.removeAttribute('aria-busy');btn.disabled=false;var l=btn.getAttribute('data-sy-label');if(l!=null)btn.innerHTML=l;if(btn.getAttribute('data-sy-price-in-label')==='1')syncTierUI(true);if(btn.getAttribute('data-sy-mode')==='view'&&TIERS[cartTier])btn.textContent='VIEW CART · '+TIERS[cartTier].price;}
}
function json(url,body){
  return fetch(url,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)}).then(function(r){if(!r.ok)throw new Error(url+' '+r.status);return r.json();});
}
function addTier(tier,btn,fallback){
  if(busy)return;busy=true;hideErr();
  var v=TIERS[tier];if(!v){busy=false;return;}
  setBusy(btn,true);
  var val=parseFloat(v.price.replace('$',''));
  track('LP_AddToCart',{tier:tier,variant_id:v.id,value:val,currency:'USD'},false);
  try{if(window.fbq)fbq('track','AddToCart',{content_ids:[String(v.id)],content_type:'product',value:val,currency:'USD'},{eventID:eid('AddToCart')});}catch(e){}
  /* V35.6 (2026-09-08): the give-up timer was 9s. On a slow connection it fired while the
     add was still in flight, so the shopper was sent to the product page even though the
     item did land in the cart. Wait longer, and before giving up, check whether it actually
     landed - if it did, open the drawer instead of navigating away. */
  var timer=setTimeout(function(){
    fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();})
      .then(function(c){
        var landed=(c.items||[]).some(function(it){return String(it.variant_id)===String(v.id)&&it.quantity>0;});
        busy=false;setBusy(btn,false);
        if(landed){setCartMode(tier);openDrawer();}else{fallback();}
      })
      .catch(function(){busy=false;setBusy(btn,false);fallback();});
  },15000);
  fetch('/cart.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();})
    .then(function(cart){
      var already=(cart.items||[]).some(function(it){return String(it.variant_id)===String(v.id)&&it.quantity>0;});
      if(already){clearTimeout(timer);busy=false;setBusy(btn,false);setCartMode(tier);track('LP_ViewCart',{tier:tier},false);openDrawer();return {skip:true};}
      var updates={},n=0;
      (cart.items||[]).forEach(function(it){
        var k=IDS[String(it.variant_id)];
        if(k&&String(it.variant_id)!==String(v.id)){updates[it.variant_id]=0;n++;}
      });
      if(n)return json('/cart/update.js',{updates:updates});
    })
    .then(function(r){
      if(r&&r.skip)return r;
      return json('/cart/add.js',{items:[{id:v.id,quantity:1}],sections:'cart-drawer,cart-icon-bubble',sections_url:location.pathname});
    })
    .then(function(state){
      if(state&&state.skip)return;
      clearTimeout(timer);busy=false;setCartMode(tier);
      setBusy(btn,true,'Added ✓');
      setTimeout(function(){setBusy(btn,false);},1400);
      var drawer=document.querySelector('cart-drawer');
      if(drawer&&typeof drawer.renderContents==='function'&&state&&state.sections){
        try{drawer.renderContents(state);return;}catch(err){}
      }
      location.href='/cart';
    })
    .catch(function(){clearTimeout(timer);busy=false;setBusy(btn,false);showErr('ajax');fallback();});
}
/* native forms (progressive enhancement) */
document.addEventListener('submit',function(e){
  var f=e.target;if(!f||!f.classList||!f.classList.contains('sy-atc'))return;
  if(!window.fetch)return;
  var idEl=f.querySelector('input[name="id"]');if(!idEl)return;
  var tier=IDS[String(idEl.value)];if(!tier)return;
  e.preventDefault();e.stopPropagation();
  var btn=f.querySelector('button');
  addTier(parseInt(tier,10),btn,function(){f.classList.remove('sy-atc');f.submit();});
},true);
/* buttons without a form (radio-tier pages) */
document.addEventListener('click',function(e){
  if(!e.target||!e.target.closest)return;
  var b=e.target.closest('button.js-atc');
  if(!b||b.closest('form'))return;
  e.preventDefault();e.stopPropagation();
  if(b.getAttribute('data-sy-mode')==='view'){track('LP_ViewCart',{tier:cartTier},false);openDrawer();return;}
  var tier=parseInt(b.getAttribute('data-tier')||'0',10)||selectedTier();
  addTier(tier,b,function(){location.href=PDP+'?tier='+tier;});
},true);

/* ---------- sticky bar / desktop card ---------- */
var bar=document.getElementById('sy-stickybar'),card=document.getElementById('syCard');
if(bar&&bar.parentNode!==document.body)document.body.appendChild(bar);
if(card&&card.parentNode!==document.body)document.body.appendChild(card);
var hero=document.getElementById('sy-hero'),buy=document.getElementById('sy-buy')||document.getElementById('sy-offer'),fin=document.getElementById('sy-final')||document.getElementById('sy-close');
var shown=null;
function visible(el){if(!el)return false;var r=el.getBoundingClientRect();var h=window.innerHeight||document.documentElement.clientHeight;return r.top<h*0.85&&r.bottom>h*0.15;}
var snap=document.getElementById('sy-snap');
var drawerEl=document.querySelector('cart-drawer');
function drawerOpen(){return drawerEl?drawerEl.classList.contains('active'):document.body.classList.contains('sy-cart-open');}
if(drawerEl&&window.MutationObserver){new MutationObserver(function(){update();setTimeout(update,60);setTimeout(update,450);}).observe(drawerEl,{attributes:true,attributeFilter:['class']});}
function update(){
  var past=snap?snap.getBoundingClientRect().bottom<0:(hero?hero.getBoundingClientRect().bottom<40:window.pageYOffset>600);
  if(!past&&hero&&hero.getBoundingClientRect().bottom<40)past=true;
  var anyModal=false;for(var i=0;i<mds.length;i++){if(!mds[i].hidden)anyModal=true;}
  var show=past&&!visible(buy)&&!visible(fin)&&!anyModal&&!drawerOpen();
  if(show===shown)return;shown=show;
  if(bar){bar.classList.toggle('show',show);bar.setAttribute('aria-hidden',show?'false':'true');}
  if(card){card.classList.toggle('on',show);card.classList.toggle('show',show);}
  document.body.classList.toggle('sy-has-sticky',show);
  if(show)track('LP_Sticky_Shown');
}
update();
window.addEventListener('scroll',update,{passive:true});
window.addEventListener('resize',update,{passive:true});
setInterval(update,700);

/* ---------- scroll depth + offer reached ---------- */
var marks=[25,50,75],seenOffer=false;
window.addEventListener('scroll',function(){
  var h=document.documentElement;var max=(h.scrollHeight-h.clientHeight)||1;
  var pct=Math.round((window.pageYOffset/max)*100);
  marks.forEach(function(m){if(pct>=m)track('LP_'+m+'_Scroll',{depth:m});});
  if(!seenOffer&&buy&&buy.getBoundingClientRect().top<=window.innerHeight*0.6){seenOffer=true;track('LP_Offer_Reached');}
},{passive:true});

/* ---------- UTM carry-through to store links ---------- */
try{
  var incoming=new URLSearchParams(location.search);
  var KEEP=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid','gclid','ttclid','ref'];
  var carry=new URLSearchParams();
  KEEP.forEach(function(k){if(incoming.get(k))carry.set(k,incoming.get(k));});
  if(!carry.get('utm_term'))carry.set('utm_term','lp_'+VARIANT);
  var links=document.querySelectorAll('.sy-adv a[href^="/products/"], .sy-adv a[href^="/cart"], #sy-stickybar a[href^="/"], #syCard a[href^="/"]');
  for(var li=0;li<links.length;li++){
    var a=links[li];var href=a.getAttribute('href')||'';
    var u=new URL(href,location.origin);
    carry.forEach(function(v,k){if(!u.searchParams.get(k))u.searchParams.set(k,v);});
    a.setAttribute('href',u.pathname+u.search+u.hash);
  }
}catch(e){}
})();
